

const warehousesaleDt = require('./warehousesale-dt')

const page           = require('../../../../components/page/page')
//const historynurseDt = require('./historynurse-dt')

import warehousesalePage       from "./warehousesale-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ //console.log('goku init>')
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", warehousesalePage)

   warehousesaleDt.start({"dest":"sale", "elem":"dt", "act":"select", "entity":"sale"})
   //historynurseDt.start({"dest":"historynurse", "elem":"dt", "act":"select", "entity":"historynurse"})

}/*init*/

/****************ELEMENTS*****************/



export function start(detail){ //console.log('investor page >', detail)
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	
	 obj[detail.act].start(detail)
}




const obj = {
   
      show:  { start: (detail)=>{  page.start(detail)     }},
}/**/


